const hasGroupActionByAutomationActionId = (state) => (groupActionId) => {
  return state.groupActionsCache.findIndex((groupAction) => groupAction.id === groupActionId) !== -1;
};

const getGroupActionByAutomationActionId = (state) => (groupActionId) => {
  return state.groupActionsCache.find((groupAction) => groupAction.id === groupActionId);
};

export default {
  hasGroupActionByAutomationActionId,
  getGroupActionByAutomationActionId,
};
